// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/webpack-edge/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll-wrap{position:absolute;height:100%;width:100%;overflow-x:hidden;overflow-y:auto;overflow-y:hidden}#app{padding:0;height:100%;max-width:100%;overflow:hidden;height:auto}#app,#app .page{display:block;width:100%;top:0;background-color:#fff}#app .page{position:absolute;padding-top:12em;overflow-x:hidden;overflow-y:scroll;height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
